import { createContext, useContext } from 'react';

import { useFlag, useFlagsStatus, useVariant } from '@fusion/feature-flags';
import { captureException } from '@sentry/browser';

export interface UseIsLocationEnabledForFeatureFlagContextInterface {
  useVariant: typeof useVariant;
  useFlag: typeof useFlag;
  useFlagsStatus: typeof useFlagsStatus;
  captureException: typeof captureException;
}

export const IsLocationEnabledForFeatureFlagContext =
  createContext<UseIsLocationEnabledForFeatureFlagContextInterface>({
    useVariant,
    useFlag,
    useFlagsStatus,
    captureException,
  });

export const useIsLocationEnabledContext =
  (): UseIsLocationEnabledForFeatureFlagContextInterface => {
    return useContext(IsLocationEnabledForFeatureFlagContext);
  };
